// API Base URL for fetch requests
// Priority: 1) window.TMS_API_BASE (injected in index.html), 2) VITE_API_BASE (build-time env), 3) '' (same origin)
const fromEnv = typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE;
const fromWindow = typeof window !== 'undefined' && window.TMS_API_BASE;
export const API_BASE = fromWindow || fromEnv || '';
